import { selector, useRecoilValue } from "recoil";
import { Theme } from "../themes/theme";
import { getLoadedLibraryData } from "./raw-library-data";

const DEFAULT_THEME: Theme = {
    bannerIsSecondaryColor: false,
    defaultColor: '#222',
    primary: { 
        b: 147,
        g: 102,
        hex: '#0D6693',
        r: 13
    },
    primaryFontColor: '#fff',
    secondary: { 
        b: 226,
        g: 205,
        hex: '#74CDE2',
        r: 116
     },
    secondaryFontColor: '#000'
};

const themeState = selector<Theme>({
    key: "Theme",
    get: ({ get }) => {
        const data = getLoadedLibraryData(get);
        if (!data) {
            return DEFAULT_THEME;
        }
        
        return {
            bannerIsSecondaryColor: data.bannerIsSecondaryColor,
            defaultColor: data.defaultColor,
            primary: {
                b: data.primaryB,
                hex: data.primary,
                g: data.primaryG,
                r: data.primaryR,
            },
            primaryFontColor: data.primaryFontColor,
            secondary: {
                b: data.secondaryB,
                hex: data.secondary,
                g: data.secondaryG,
                r: data.secondaryR,
            },
            secondaryFontColor: data.secondaryFontColor
        } as Theme;
    }
});

export const useTheme = () => useRecoilValue(themeState);
